import { CtaLeftAlign } from '@definitions/types/storyblokTypes'

import { createStoryblokAsset } from '../../../../../__mocks__/storyblok/createStoryblokAsset'
import { createStoryblokMultilink } from '../../../../../__mocks__/storyblok/createStoryblokMultilink'
import { createStoryblokRichtext } from '../../../../../__mocks__/storyblok/createStoryblokRichtext'

/**
 * Creates a mock CtaLeftAlign
 * @param overrides - Partial fields to override defaults
 * @returns Complete CtaLeftAlign mock
 */
export function createCtaLeftAlign(
  overrides: Partial<CtaLeftAlign> = {}
): CtaLeftAlign {
  return {
    _uid: '17091d45-1adf-44a6-b5d5-2efceed28fbe',
    link: createStoryblokMultilink({
      id: '50d1b16c-e98c-4255-a068-8fe147ec27db',
      linktype: 'story',
      cached_url: 'sunpoint/home',
    }),
    image: createStoryblokAsset({
      id: 9757937,
      filename:
        'https://a.storyblok.com/f/235453/1920x445/0868c8320d/filiale.jpg',
      src: 'https://a.storyblok.com/f/235453/1920x445/0868c8320d/filiale.jpg',
      width: 1920,
      height: 445,
      aspect_ratio: 4.31,
      content_type: 'image/jpeg',
      updated_at: '2024-01-01T00:00:00.000Z',
    }),
    button: 'dassdsadd',
    content: createStoryblokRichtext('dsadssadsdssd'),
    headline: 'Headline',
    component: 'cta-left-align',
    _editable:
      '<!--#storyblok#{"name": "cta-left-align", "space": "235453", "uid": "17091d45-1adf-44a6-b5d5-2efceed28fbe", "id": "424177377"}-->',
    ...overrides,
  }
}
